import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import Toggle from 'react-toggle'
import ImageCropper from '../../../common/ImageCropper/ImageCropper.js'
import ReactQuill from 'react-quill'

class TripCabinAdd extends React.Component {
  state = {
    status: 'active',
    name_en: '',
    name_ar: '',
    capacity: '',
    max_cabins: '',
    adult_price: 0,
    child_price: 0,
    img_en: '',
    img_ar: '',
    order: '',
    is_active: false,
    isSaving: false,
    isData: false,
    Edit: false,
    desc_ar: '',
    desc_en: '',
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.id) {
        this.getCruiseCabinDetails()
      }
    }, 100)
  }

  getCruiseCabinDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-cruise-cabin-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const cruiseCabinData = res.data.data
          this.setState({
            ...cruiseCabinData,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    if (event?.target?.name === 'is_active') {
      this.setState({ [event.target.name]: event.target.checked })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })
    if (imgKeyName == 'img_ar') {
      this.setState({ imgAr: URL.createObjectURL(e) })
    } else {
      this.setState({ imgEn: URL.createObjectURL(e) })
    }
  }

  onSaveData = () => {
    const formData = new FormData()
    formData.append('cruise_id', this.props.cruiseId)
    formData.append('name_en', this.state.name_en)
    formData.append('name_ar', this.state.name_ar)

    formData.append('desc_en', this.state.desc_en)
    formData.append('desc_ar', this.state.desc_ar)

    formData.append('capacity', this.state.capacity)
    formData.append('max_cabins', this.state.max_cabins)
    formData.append('adult_price', this.state.adult_price)
    formData.append('child_price', this.state.child_price)
    formData.append('is_active', this.state.is_active)

    this.setState({ isData: true })

    if (this.state.img_en?.type) {
      formData.append('img_en', this.state.img_en, 'your_original_filename.jpeg')
    }
    if (this.state.img_ar?.type) {
      formData.append('img_ar', this.state.img_ar, 'your_original_filename.jpeg')
    }

    if (this.props.id) {
      formData.append('id', this.props.id)

      axios
        .put(Constant.getAPI() + '/trips/update-cruise-cabin', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Cruise Cabin has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/trips/add-cruise-cabin', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Cruise Cabin has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_en"
                    id="name_en"
                    placeholder={`Cruise Cabin Name: English`}
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    id="name_ar"
                    placeholder={`Cruise Cabin Name: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Capacity</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="capacity"
                    id="capacity"
                    placeholder={`Cruise Cabin Capacity`}
                    onChange={this.handleChange}
                    value={this.state.capacity}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Maximum Cabins</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="max_cabins"
                    id="max_cabins"
                    placeholder={`Maximum Cabins`}
                    onChange={this.handleChange}
                    value={this.state.max_cabins}
                  />
                </div>
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Adult Price</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="adult_price"
                    id="adult_price"
                    placeholder={`Adult Price`}
                    onChange={this.handleChange}
                    value={this.state.adult_price}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Child Price</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="child_price"
                    id="child_price"
                    placeholder={`Child Price`}
                    onChange={this.handleChange}
                    value={this.state.child_price}
                  />
                </div>
              </div>
            </div> */}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="desc_en"
                    id="desc_en"
                    value={this.state.desc_en}
                    onChange={(value) => {
                      this.setState({
                        desc_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="desc_ar"
                    id="desc_ar"
                    value={this.state.desc_ar}
                    onChange={(value) => {
                      this.setState({
                        desc_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Is Active</label>
                <div className="col-sm-9">
                  <Toggle
                    name="is_active"
                    id="is_active"
                    onChange={this.handleChange}
                    checked={this.state.is_active}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: English</div>
                <div className="col-sm-5">
                  <div style={{ color: 'red', fontWeight: 'bold' }}>Image size should be 500*500</div>
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_en || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_en')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: Arabic</div>
                <div className="col-sm-5">
                  <div style={{ color: 'red', fontWeight: 'bold' }}>Image size should be 500*500</div>
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_ar || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_ar')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={`/trip-cabin/${this.props.cruiseId}`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default TripCabinAdd
